import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import Module from "utilities/global/sparta-module-utility/6.3.1/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.9/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.9/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.10/js/sparta-ui-layers-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import currentWidgetDetails from "utilities/platform/widget-details";
import spartaTemplates from "modules/login/secure-ah-omni-channel-auth-main-module/1.4.1/js/templates";
import "css!modules/login/secure-ah-omni-channel-auth-main-module/1.4.1/css/secure-ah-omni-channel-auth-main-module.scss.css";










export default class SecureAhOmniChannelAuthMainModule extends Module {





  constructor(options) {
     Object.assign(options, {
      target: options.target,
      debug: true
    });
    super(options);
    this.errorText = {};
    this.errorText = options.errorText;
    const that = this;
    this.endpoints = options.url;
    this.widgetJCR = options.bolText;
    this.Events.sub(cawEventsMasterUtility.EVENTS.INTERNAL.SIGNIN_READY, (e) => {
          options.clientParams.originatingFrom = 'CAW';
          that.Events.pub(cawEventsMasterUtility.EVENTS.INTERNAL.CAW_CLIENTPARAMS, options.clientParams);
          if (options.clientParams['skin-name']) {
            const target = that.view.settings.$target;
            target.find('[data-component=module], [data-component=module] > div')
              .addClass(options.clientParams['skin-name']);
            target.addClass(options.clientParams['skin-name']);
            target.find(`#ah-authcode-container.${options.clientParams['skin-name']}`).addClass('hidden');
            this.isModal = options.clientParams.isModal;
            self.skinName = options.clientParams['skin-name'];
          }
    });

    this.initVars(options);
  }

  init(args = {}) {
    const that = this;

    that.currLang = document.querySelector("html").lang;
    that.isEs = that.currLang.includes('es');
    if (!that.isEs) {
      that.Store.addData('jcrLang', 'en');
    }
    if(that.widgetJCR) {
      that.Store.addData('WidgetJCRData', that.widgetJCR);
    }
    this.subscribeEvents();
    this.loadAuthHelper();
  }
  loadAuthHelper(){
    var loader = document.createElement("script");
    loader.type = "text/javascript";
    if((window.location.host.indexOf('localhost') > -1))
    {
      loader.src = "http://localhost:3005/spa/widgets/"+this.applicationContext.name+"/"+this.applicationContext.version+"/spa-assets/components/utilities/client-helper/authhub-controller/authhub-helper/1.0.0/js/authhub-helper.js"
    }
    else{
      loader.src = this.spaParams.siteParams.domain.hostname+"/client/helper/spa-assets/components/utilities/client-helper/authhub-controller/authhub-helper/1.0.0/js/authhub-helper.js";
    }

        document.getElementsByTagName("head")[0].appendChild(loader);
    document.cookie ='DomainUrl='+this.spaParams.siteParams.domain.hostname;
  }
  setADAstate(state, targetSection) {
    let el = document.getElementById(targetSection);
    if(state === "hide") {
      el.children[0]
        .classList
        .add('ada-hidden');
      el.children[0]
        .setAttribute('aria-hidden', 'true');
    } else {
      el.children[0]
        .classList
        .remove('ada-hidden')
      el.children[0]
        .setAttribute('aria-hidden', 'false');
    }
  }




  initVars(options) {
    const basePath = ahCawCommons.getBasePath(this.spaParams);
    this.url = {
      postAuth: basePath + options.url.postAuth,
      forgotOidPass: basePath + options.url.forgotOidPass,
      signin: basePath + options.url.signin,
      enroll: basePath + options.url.enroll.replace('{LOCALE}', $('html').attr('lang')),
      atpForgotOid: basePath + options.url.atpForgotOid,
      atpForgotPass: basePath + options.url.atpForgotPass,
      atpEnroll: basePath + options.url.atpEnroll
    };
    this.endpoints = options.url;
  }

  closeModal() {
    $(this.settings.$target).find('#ah-caw-main-container').addClass('hidden');
    if (self.isModal === 'true' || self.isModal === true){
       spartaUILayersUtility.closeLayer($('#caw-modal-contentSpartaUILayer'));
       $(document).find(`[data-sparta-container='secure-ah-omni-channel-auth-widget'] .sparta-widget`).empty();
    }
  }




  subscribeEvents() {
    const that = this;
    this.cawModalLayer = {};

    this.Events.sub('SPARTA_GLOBAL_READY.spartaBootstrapUtility', () => {
      that.Events.pub('Error-Data', that.errorText);
    });


    this.Events.sub('AH_CAW_WIDGET_CONF',(e)=>{
          const widgetInfo = e.data;
          const target = that.view.settings.$target;
          self.widgetInfo = widgetInfo;
          target.find('[data-component=module], [data-component=module] > div')
            .addClass( widgetInfo['skin-name']);
          target.addClass( widgetInfo['skin-name']);
          target.find(`#ah-authcode-container.${widgetInfo['skin-name']}`).addClass('hidden');
          self.isModal = widgetInfo.isModal;
          self.skinName = widgetInfo['skin-name'];
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.SHOW_MAIN_CONTAINER, () => {
      that._widgetPaint();
      const target = $(this.settings.$target);
      target.find('#ah-caw-main-container').removeClass('hidden');
      target.find(`#ah-authcode-container.${self.skinName}`).addClass('hidden');
      target.find('#ah-cq-container').addClass('hidden');
      target.find('#ah-dp-container').addClass('hidden');

      this.Events.pub(cawEventsMasterUtility.EVENTS.SHOW_WIDGET_FOOTER_HELP_OPTIONS);
      target.find('.js-caw-noresp').removeClass('large-12 medium-6 small-12');

      if (self.isModal === 'true' || self.isModal === true) {
        this.modalContentID = 'caw-modal-content';
        const $modalContentWrapper = $('#modal-wrapper');

        const options = {
          type: 'modal',
          closeOnEscape: true,
          closeButton: true,
          optionalClasses: `caw-modal-content ${self.skinName}`,
          contentId: this.modalContentID,
          width: 'auto',
        };

        $modalContentWrapper.data('options', options);


        if (!that.isEs) {
          $("html").attr("lang", 'en-us');
        }

        this.Events.sub("MODAL_OPENED.spartaUILayersUtility", function(e) {
          if (_.get(e, "data.contentId") === that.modalContentID) {
            const modalTarget = $(`#${that.modalContentID}SpartaUILayer`);
            modalTarget.find('#ah-cq-container,#ah-authcode-container,#ah-dp-container').addClass('hidden');
            that.bindEventHandlers('modal');
          }

        });
        this.Events.sub("MODAL_CLOSE.spartaUILayersUtility", function(e) {
          $(document).find(`[data-sparta-container='secure-ah-omni-channel-auth-widget'] .sparta-widget`).empty();
        });
        this.cawModalLayer = spartaUILayersUtility.openLayer($modalContentWrapper);
      }
      this.bindEventHandlers();

      that.setADAstate("hide", "creditc-details");
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.AH_AUTH_FINISH_SUCCESS, (e) => {
      $(this.settings.$target).find('#ah-caw-main-container').addClass('hidden');
      if (self.isModal === 'true' || self.isModal === true){
        spartaUILayersUtility.closeLayer($('#caw-modal-contentSpartaUILayer'));
      }
      if(e.data.Status === 'SUCCESS'){
        this.Events.pub('AH_INTERNAL_PROCESS_SUCCESS',e.data);
      }else{
        this.Events.pub('AH_INTERNAL_PROCESS_FAILED',e.data);
      }

     $(document).find(`[data-sparta-container='secure-ah-omni-channel-auth-widget'] .sparta-widget`).empty();
    });

    this.Events.sub('OCA_AUTH_CANCEL', () => {
      if (!that.isEs) {

        $("html").attr("lang", that.currLang);
      }

      $(this.settings.$target).find('#ah-caw-main-container').addClass('hidden');
      if (self.isModal === 'true' || self.isModal === true){
         spartaUILayersUtility.closeLayer($('#caw-modal-contentSpartaUILayer'));

         that.Events.pub('AH_INTERNAL_PROCESS_CANCELED',"");
         $(document).find(`[data-sparta-container='secure-ah-omni-channel-auth-widget'] .sparta-widget`).empty();
      }
    });

    this.Events.sub('AH_UNIVERSAL_OTP_SEND_CODE_FAILURE', (e) => {
      this.Events.pub('OTP_SEND_CODE_FAILURE', e.data);
      if(self.widgetInfo.isModal ==='true'){
        this.closeModal();
    }

          });

    this.Events.sub("AH_CAW_COMMON_ERROR", (e) => {
       let AuthData = {
          "Status": "FAILED",
       }
       this.Events.pub('AH_INTERNAL_PROCESS_FAILED',AuthData);
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.INTERNAL.POST_AUTH, (e) => {
      if(self.widgetInfo.domain){
        this.url = ahCawCommons.getEndPoints(this.endpoints, self.widgetInfo.domain);
      }
      if(self.widgetInfo&&self.widgetInfo.originatingFrom === 'OCA-GWIM'){
        let AuthData = {};
        if( _.get(e.data,'redirectResult.authResult')){
           AuthData = {
              "Status": _.get(e.data,'redirectResult.authResult') 
            }
        }else if(_.get(e.data,'Completion.value')==='ALLOW'){ 
           AuthData = {
              "Status": "SUCCESS"
            }
        }

        $( "#ah-caw-main-container a").attr({"disabled":"disabled"});
        $( "#ah-caw-main-container button").attr({"disabled":"disabled"});
        $( "#ah-caw-main-container input").attr({"disabled":"disabled"});
        window.setTimeout(function() {
          $( "#ah-caw-main-container a").removeAttr("disabled");
          $( "#ah-caw-main-container button").removeAttr("disabled");
          $( "#ah-caw-main-container input").removeAttr("disabled");
          that.Events.pub(cawEventsMasterUtility.EVENTS.AH_AUTH_FINISH_SUCCESS, AuthData);
        },3000);

      }else{

        const postAuthOption = {
          method: 'GET',
          url: this.url.postAuth, 
          crossDomain: true,
          cache: false,
          timeout: 60000,
          processData: false,
          xhrFields: {
            withCredentials: true,
          },
          headers: {
            'cache-control': 'no-cache',
          },
        };
        const cawTransport = new ahCawTransportUtility();
        cawTransport._serviceCall(postAuthOption, (response) => {
         window.setTimeout(function(){
            $( "#ah-caw-main-container a").attr({"disabled":"disabled"});
            $( "#ah-caw-main-container button").attr({"disabled":"disabled"});
            $( "#ah-caw-main-container input").attr({"disabled":"disabled"});
          });
          window.setTimeout(function() {
            const data = { response: response.responseData.token };
            let AuthData = {};
            if(self.widgetInfo && self.widgetInfo.clientId === 'BOFA-PCE'){
              const jwtToken = response.responseData.token.value.text;
              AuthData = {
                "Status": _.get(response.responseData,'completion.code'),
                "DCAffinity": that.SpartaFunctions.spartaGetCookie('SPID').substring(0,1),
                "Error":_.get(response.responseData,'errorInfo.error')?_.get(response.responseData,'errorInfo.error') : _.get(response.responseData,'completion.code'),
                "JWTtoken": jwtToken
              }
            }else{
              AuthData = {
                  "Status": _.get(response.responseData,'completion.code'),
                  "DCAffinity": that.SpartaFunctions.spartaGetCookie('SPID').substring(0,1),
                  "Error":_.get(response.responseData,'errorInfo.error')?_.get(response.responseData,'errorInfo.error') : _.get(response.responseData,'completion.code')
              }

            }

                       if (e.data.successCallback) {
              e.data.successCallback(AuthData);
            }
            $( "#ah-caw-main-container a").removeAttr("disabled");
            $( "#ah-caw-main-container button").removeAttr("disabled");
            $( "#ah-caw-main-container input").removeAttr("disabled");
            that.Events.pub(cawEventsMasterUtility.EVENTS.AH_AUTH_FINISH_SUCCESS, AuthData);
          },3000);
        }, (ex) => {
          console.log(ex.responseText);
        });
      }
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.AH_OTP_CLEANUP, (e)=>{
      const target = $(this.settings.$target);
      target.find('#ah-authcode-container').addClass('hidden');

      if(target.find('#ah-authcode-container').length === 0){
        $('#ah-authcode-container').addClass('hidden');
      }
    });

    this.Events.sub(cawEventsMasterUtility.EVENTS.AH_MTG_CLEANUP, (e)=>{
      const target = $(this.settings.$target);
      target.find('#ah-mtg-container').addClass('hidden');

      if(target.find('#ah-mtg-container').length === 0){
        $('#ah-mtg-container').addClass('hidden');
      }
    });


    this.Events.sub("Di_Auth_Success", (e) => {
      this._triggerPostAuthService();

        }, true); 
  }

  _triggerPostAuthService(){

               const postAuthUrl = this.url.postAuth;
    const ajaxOptions = {
    method: 'GET',
    url: postAuthUrl,
    crossDomain: true,
    cache: false,
    timeout: 60000,
    processData: false,
    xhrFields: {
        withCredentials: true,
    },
    dataType: 'json',
    headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        'cache-control': 'no-cache',
    },
};
const initiateCall = new ahCawTransportUtility();
initiateCall._serviceCall(ajaxOptions, (response) => {
  const data = response.responseData;
  window.location.replace(data.return2Url);
  });
  }

  _widgetPaint(){
    const that = this,
      forcedReset = (location.href.indexOf("reset-password-flow") > 0);
    let widgetJCRInfo = that.Store.getData('WidgetJCRData');
    if(self.widgetInfo){
      if(self.widgetInfo.enrollLnk === 'skip'){
         $('#secure-signin-enroll').remove();
      }
      if (forcedReset === false) {
        if(self.widgetInfo.forgotIdLnk === 'skip'){
          $('#forgot-oid-pass').remove();
          $('#forgot-oid').remove();
          $('#gwim-forgot').remove();
        }
        if(self.widgetInfo.resetPassLnk === 'skip'){
          $('#forgot-oid-pass').remove();
          $('#forgot-pwd').remove();
          $('#gwim-forgot').remove();
        }
        if(self.widgetInfo.forgotIdLnk ==='skip' && self.widgetInfo.resetPassLnk==='skip'){
          $('#ocaFooterModule').remove();
        }
      }
      if(self.widgetInfo.isModal !=='true'){
        $('#secure-signin-cancel-bol').remove();
      }
    }

    if(self.widgetInfo.enableDI !== 'true'){
     $('#signin-with-mobile-app-link').addClass('hidden');
   }
    if (self.widgetInfo['skin-name'] === 'bol-skin') {
        widgetJCRInfo = that.Store.getData('WidgetJCRData');
        if(_.get(widgetJCRInfo,'formInfo.oid')){
          $('#oid').attr('placeholder',widgetJCRInfo.formInfo.oid);
          $('#pass').attr('placeholder',widgetJCRInfo.formInfo.pass);
          widgetJCRInfo.loginTitle ? $('#ahPageTitleContainer h3').html(widgetJCRInfo.loginTitle) : '';
        }

        $('#title-content').addClass('column small-9');
        $('#BOL-logo-content').removeClass('hidden');
        $('#OLB-logo-content').remove();
        $('#signin-with-mobile-app-link').addClass('hidden');
        $(this.settings.$target).find('#gwim-forgot').removeClass('hidden');
        $(this.settings.$target).find('#caw-forgot').addClass('hidden');
        if(self.widgetInfo.isModal === 'true'){
          $(this.settings.$target).find('#ah-main-bol-header').removeClass('hidden');
          $(this.settings.$target).find('#ah-main-bol-footer').removeClass('hidden');
          $(this.settings.$target).find('#ah-main-consumer-header').addClass('hidden');
          $(this.settings.$target).find('#ah-main-consumer-footer').addClass('hidden');
        }

    } else {
      if (self.widgetInfo.originatingFrom === "ATP-CAW"){
        $(this.settings.$target).find('#third-party-forgot').removeClass('hidden');
        $(this.settings.$target).find('#caw-forgot').addClass('hidden');
        $(this.settings.$target).find('#cawHeader').text(widgetJCRInfo.atp["atp-header"]);
        $(this.settings.$target).find('.js-show-nocontacts').children("div").eq(0).text(widgetJCRInfo.atp["atp-verify-no-contact"]);
        $(this.settings.$target).find('.js-show-nocontacts').children("div").eq(1).html(widgetJCRInfo.atp["atp-call-for-code"]);
        $(this.settings.$target).find('.input-radio-voice').addClass('hidden');  
        $(this.settings.$target).find('#otp-caw-footer-container .disclaimer-sub').text(widgetJCRInfo.atp["atp-carrier-list"]);

             }

      if(self.widgetInfo.isModal === 'true') {
        $('#title-content').addClass('column small-9');
        $('#OLB-logo-content').removeClass('hidden');
        $('#BOL-logo-content').remove();
        $(this.settings.$target).find('#ah-main-bol-header').addClass('hidden');
        $(this.settings.$target).find('#ah-main-bol-footer').addClass('hidden');

        if(self.widgetInfo['skin-name'] === 'sb-skin') {
          $('#oid').attr('placeholder',widgetJCRInfo.formInfo.oid);
          $('#pass').attr('placeholder',widgetJCRInfo.formInfo.pass);
          widgetJCRInfo.loginTitle ? $('#ahPageTitleContainer h3').html(widgetJCRInfo.loginTitle) : '';
        }

        if (self.widgetInfo['skin-name'] === 'caw-skin') {
          $(this.settings.$target).find('#ah-main-consumer-header').removeClass('hidden');
          $(this.settings.$target).find('#ah-main-consumer-footer').removeClass('hidden');
        } else {
          $(this.settings.$target).find('#ah-main-sb-header').removeClass('hidden');
          $(this.settings.$target).find('#ah-main-sb-footer').removeClass('hidden');
        }
      }
    }


    if(self.widgetInfo&&(self.widgetInfo['usecase']==='LINKAGE'|| self.widgetInfo['usecase']==='linkBOL')){
       if(_.get(widgetJCRInfo,'formInfo.link')){
        $('#caw-signin #secure-signin-submit').text(widgetJCRInfo.formInfo.link);
      }
    }
    $(this.settings.$target).find('#secure-signin-cancel-bol').removeClass('hidden');


    let bolEp = this.spaParams.siteParams.bolEndpoint;
    let resetoidurl = bolEp + $('#gwim-forgot #forgot-oid').attr('data-href');
    let resetpwdurl = bolEp + $('#gwim-forgot #forgot-pwd').attr('data-href');
    $('#gwim-forgot #forgot-oid').attr("href",resetoidurl);
    $('#gwim-forgot #forgot-pwd').attr("href",resetpwdurl);
  }




  bindEventHandlers(type) {
    let target = this.view.settings.$target;
    const that = this;
    if (type === 'modal') {
      target = `#${that.modalContentID}SpartaUILayer`;
    }

    $(target).off('click.forgotIdPass', '.js-forgotIdPass').on('click.forgotIdPass', '.js-forgotIdPass', function() {
      window.open(that.url.forgotOidPass, '');
    });
    $(target).off('click.atpForgotId', '.js-atp-forgotId').on('click.atpForgotId', '.js-atp-forgotId', function() {
      window.open(that.url.atpForgotOid, '');
    });
    $(target).off('click.atpForgotPass', '.js-atp-forgotPass').on('click.atpForgotPass', '.js-atp-forgotPass', function() {
      window.open(that.url.atpForgotPass, '');
    });

        $(target).off('click.enroll', '.js-enroll').on('click.enroll', '.js-enroll', function() {
      window.open(that.url.enroll, '');
    });
    $(target).off('click.signin', '.js-signin').on('click.signin', '.js-signin', function() {
      window.open(that.url.signin, '');
    });

    $('#caw-modal-contentSpartaUILayerClose').off("click.close").on('click.close', function() {
      if (!that.isEs) {

        $("html").attr("lang", that.currLang);
      }
      that.Events.pub('AH_INTERNAL_PROCESS_CANCELED',"");
      $(document).find(`[data-sparta-container='secure-ah-omni-channel-auth-widget'] .sparta-widget`).empty();
    });


    let $elsSelector = $('#oid, #spa-challenge-ans1, #spa-challenge-ans2, #caw-modal-contentSpartaUILayerClose');
    $elsSelector
      .off('focus')
      .on('focus', () => {
        $('#ahPageTitleContainer h3, #ah-caw-footer-container #forgot-oid-pass')
          .attr("aria-hidden", "true");
      return false;
    });

    $elsSelector
      .off('focusout ')
      .on('focusout ', () => {
        $('#ahPageTitleContainer h3, #ah-caw-footer-container #forgot-oid-pass')
          .removeAttr("aria-hidden");
        return false;
      });




    $('#forgot-oid-pass')
      .off('focusout')
      .on('focusout', () => {
        $('#caw-modal-contentSpartaUILayerClose').focus();
      });

    $(target).find('input:not(:button)').off("keyup.handleReturn").on("keyup.handleReturn", (e) => {
      let keyVal = e.which || e.keyCode;
      if (keyVal === 13) {
        if ($(target).find('[default-button]:visible').length === 1) {
          $(target).find('[default-button]:visible').click();
          e.stopPropagation();
          e.preventDefault();
          return false;
        }
      }
    });




    $('#pass')
    .off('focusout')
    .on('focusout', () => {
      that.setADAstate("", "creditc-details");
    })
  }
}
